<template>
  <div class="skeleton-card shimmer">
    <div class="skeleton-logo"></div>

    <div class="skeleton-content">
      <div class="skeleton-title"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line short"></div>
    </div>

    <div class="skeleton-close"></div>
  </div>
</template>

<style scoped>
/* ---------- CARD ---------- */
.skeleton-card {
  width: 290px;
  height: 100px;
  background: var(--background-secondary, #f5f5f5);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

/* ---------- ELEMENTS ---------- */
.skeleton-logo,
.skeleton-title,
.skeleton-line,
.skeleton-close {
  background: #dcdcdc; /* light theme default */
  border-radius: 6px;
  transition: background-color 0.25s ease;
}

/* Logo */
.skeleton-logo {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

/* Content */
.skeleton-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeleton-title {
  width: 55%;
  height: 10px;
}

.skeleton-line {
  width: 80%;
  height: 10px;
}

.skeleton-line.short {
  width: 60%;
}

/* Close icon */
.skeleton-close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 14px;
  right: 14px;
}

/* ---------- SHIMMER ---------- */
.shimmer::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150px;
  width: 150px;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.35),
    transparent
  );
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(0); }
  100% { transform: translateX(300%); }
}

/* ========================================
   🔥 DARK THEME (data-theme="dark")
   ======================================== */
html[data-theme="dark"] .skeleton-card {
  background: #2b2b2b !important;
}

html[data-theme="dark"] .skeleton-logo,
html[data-theme="dark"] .skeleton-title,
html[data-theme="dark"] .skeleton-line,
html[data-theme="dark"] .skeleton-close {
  background: #3c3c3c !important; /* darker blocks */
}

html[data-theme="dark"] .shimmer::before {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.12),
    transparent
  ) !important;
}

@media (max-width: 430px) {
  .skeleton-card {
    width: 100%;
    min-height: 118px;
    height: auto;

    padding: 14px;
    border-radius: 18px;

    gap: 12px;
  }

  .skeleton-logo {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
  }

  .skeleton-content {
    gap: 8px;
    min-width: 0;
  }

  .skeleton-title {
    width: 58%;
    height: 12px;
    border-radius: 8px;
  }

  .skeleton-line {
    width: 92%;
    height: 10px;
    border-radius: 8px;
  }

  .skeleton-line.short {
    width: 70%;
  }

  .skeleton-close {
    width: 18px;
    height: 18px;

    top: 14px;
    right: 14px;
  }

  .shimmer::before {
    width: 120px;
  }
}

</style>